import React, { useEffect, useState } from 'react';
import { getVeiculos, criarVeiculo, atualizarVeiculo, deletarVeiculo, getEquipamentos } from '../services/api';

function IosField({ label, children }) {
    return (
        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
            <div style={{ padding: '0 16px' }}>
                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>
                    {label}
                </span>
                {children}
            </div>
        </div>
    );
}

const inputStyle = {
    width: '100%', border: 'none', outline: 'none', fontSize: 15,
    fontFamily: 'var(--ios-font)', color: 'var(--ios-label)',
    background: 'transparent', padding: '8px 0 10px', boxSizing: 'border-box',
};

function SeletorRastreador({ label, value, onChange, equipamentos, excluirId }) {
    const disponiveis = equipamentos.filter(e =>
        e.status === 'ativo' &&
        (!e.veiculo_principal && !e.veiculo_redundante || e.id === value) &&
        e.id !== excluirId
    );

    return (
        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
            <div style={{ padding: '0 16px' }}>
                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>{label}</span>
                <select style={{ ...inputStyle, appearance: 'none' }} value={value || ''} onChange={e => onChange(e.target.value ? parseInt(e.target.value) : null)}>
                    <option value="">Nenhum</option>
                    {disponiveis.map(e => (
                        <option key={e.id} value={e.id}>{e.fabricante} {e.modelo} — {e.imei}{e.operadora ? ` (${e.operadora})` : ''}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}

function Modal({ veiculo, equipamentos, onSalvar, onFechar }) {
    const [form, setForm] = useState({
        nome: veiculo?.nome || '',
        placa: veiculo?.placa || '',
        fabricante: veiculo?.fabricante || '',
        modelo: veiculo?.modelo || '',
        cor: veiculo?.cor || '',
        ano: veiculo?.ano || '',
        rastreador1_id: veiculo?.rastreador1_id || null,
        rastreador2_id: veiculo?.rastreador2_id || null,
        alerta_sonoro: veiculo?.alerta_sonoro || false,
    });
    const [erro, setErro] = useState('');
    const [salvando, setSalvando] = useState(false);

    const set = campo => e => setForm(f => ({ ...f, [campo]: e.target.value }));

    const salvar = async () => {
        setErro(''); setSalvando(true);
        try {
            veiculo ? await atualizarVeiculo(veiculo.id, form) : await criarVeiculo(form);
            onSalvar();
        } catch(e) {
            setErro(e.response?.data?.erro || 'Erro ao salvar');
        } finally { setSalvando(false); }
    };

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 420, maxWidth: '95vw' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)' }}>
                    <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#ff3b30', fontSize: 15, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                    <span style={{ fontWeight: 600, fontSize: 16, color: 'var(--ios-label)' }}>{veiculo ? 'Editar Veículo' : 'Novo Veículo'}</span>
                    <button onClick={salvar} disabled={salvando} style={{ background: 'none', border: 'none', color: '#007aff', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>
                        {salvando ? '...' : 'Salvar'}
                    </button>
                </div>

                <div style={{ padding: '20px 16px', background: 'var(--ios-gray6)', overflowY: 'auto', maxHeight: '75vh' }}>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Identificação</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <IosField label="Nome">
                            <input style={inputStyle} placeholder="Ex: Caminhão 01" value={form.nome} onChange={set('nome')} />
                        </IosField>
                        <IosField label="Placa">
                            <input style={inputStyle} placeholder="Ex: ABC1D23" value={form.placa} onChange={set('placa')} />
                        </IosField>
                    </div>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Veículo</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <IosField label="Fabricante">
                            <input style={inputStyle} placeholder="Ex: Volkswagen, Ford, Toyota..." value={form.fabricante} onChange={set('fabricante')} />
                        </IosField>
                        <IosField label="Modelo">
                            <input style={inputStyle} placeholder="Ex: Gol, Hilux, Sprinter..." value={form.modelo} onChange={set('modelo')} />
                        </IosField>
                        <IosField label="Cor">
                            <input style={inputStyle} placeholder="Ex: Branco, Prata, Preto..." value={form.cor} onChange={set('cor')} />
                        </IosField>
                        <IosField label="Ano">
                            <input style={inputStyle} placeholder="Ex: 2023" value={form.ano} onChange={set('ano')} inputMode="numeric" maxLength={4} />
                        </IosField>
                    </div>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Rastreadores</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <SeletorRastreador
                            label="Rastreador Principal"
                            value={form.rastreador1_id}
                            onChange={v => setForm(f => ({ ...f, rastreador1_id: v }))}
                            equipamentos={equipamentos}
                            excluirId={form.rastreador2_id}
                        />
                        <SeletorRastreador
                            label="Rastreador Redundante (opcional)"
                            value={form.rastreador2_id}
                            onChange={v => setForm(f => ({ ...f, rastreador2_id: v }))}
                            equipamentos={equipamentos}
                            excluirId={form.rastreador1_id}
                        />
                    </div>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Alertas</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <div onClick={() => setForm(f => ({ ...f, alerta_sonoro: !f.alerta_sonoro }))}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px', cursor: 'pointer', background: 'white' }}>
                            <div>
                                <div style={{ fontSize: 15, color: 'var(--ios-label)', fontWeight: 400 }}>Alerta sonoro de ignição</div>
                                <div style={{ fontSize: 12, color: 'var(--ios-gray)', marginTop: 2 }}>Toca um sino ao ligar ou desligar</div>
                            </div>
                            <div style={{
                                width: 51, height: 31, borderRadius: 16, position: 'relative', flexShrink: 0,
                                background: form.alerta_sonoro ? '#34c759' : '#e5e5ea',
                                transition: 'background 0.2s', cursor: 'pointer',
                            }}>
                                <div style={{
                                    position: 'absolute', top: 2, left: form.alerta_sonoro ? 22 : 2,
                                    width: 27, height: 27, borderRadius: '50%', background: 'white',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                                }}/>
                            </div>
                        </div>
                    </div>

                    {erro && <div style={{ background: 'rgba(255,59,48,0.08)', borderRadius: 10, padding: '10px 14px', color: '#ff3b30', fontSize: 13 }}>{erro}</div>}
                </div>
            </div>
        </div>
    );
}

export default function Cadastro({ onFechar }) {
    const [veiculos, setVeiculos] = useState([]);
    const [equipamentos, setEquipamentos] = useState([]);
    const [editando, setEditando] = useState(null);
    const [novo, setNovo] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);

    const carregar = async () => {
        const [rv, re] = await Promise.all([getVeiculos(), getEquipamentos()]);
        setVeiculos(rv.data);
        setEquipamentos(re.data);
    };

    useEffect(() => { carregar(); }, []);

    const excluir = async (id) => {
        await deletarVeiculo(id);
        setConfirmDelete(null);
        carregar();
    };

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 620, maxWidth: '96vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0 }}>
                    <span style={{ fontWeight: 600, fontSize: 17, color: 'var(--ios-label)' }}>Veículos</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={() => setNovo(true)}>+ Novo</button>
                        <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={onFechar}>Fechar</button>
                    </div>
                </div>

                <div style={{ overflowY: 'auto', flex: 1, padding: 16 }}>
                    {veiculos.length === 0 ? (
                        <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40, fontSize: 15 }}>Nenhum veículo cadastrado</div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 1, borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                            {veiculos.map((v, i) => (
                                <div key={v.id} style={{
                                    background: 'white', padding: '13px 16px',
                                    display: 'flex', alignItems: 'center', gap: 12,
                                    borderBottom: i < veiculos.length - 1 ? '1px solid var(--ios-separator)' : 'none',
                                }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 600, fontSize: 15, color: 'var(--ios-label)' }}>{v.nome}</div>
                                        <div style={{ fontSize: 12, color: 'var(--ios-gray)', marginTop: 2 }}>
                                            {v.placa}
                                            {v.fabricante && ` · ${v.fabricante} ${v.modelo || ''}`}
                                            {v.cor && ` · ${v.cor}`}
                                            {v.ano && ` · ${v.ano}`}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#aeaeb2', marginTop: 3 }}>
                                            {v.imei ? `📡 ${v.modelo_rastreador} ${v.imei}` : '⚠️ Sem rastreador'}
                                            {v.imei2 && ` · 📡 ${v.modelo_rastreador2} ${v.imei2}`}
                                        </div>
                                    </div>
                                    {v.alerta_sonoro && <span style={{ fontSize: 13 }} title="Alerta sonoro ativo">🔔</span>}
                                    <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={() => setEditando(v)}>Editar</button>
                                    <button className="ios-btn ios-btn-sm" style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30' }} onClick={() => setConfirmDelete(v)}>Excluir</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {(novo || editando) && (
                <Modal
                    veiculo={editando}
                    equipamentos={equipamentos}
                    onSalvar={() => { setNovo(false); setEditando(null); carregar(); }}
                    onFechar={() => { setNovo(false); setEditando(null); }}
                />
            )}

            {confirmDelete && (
                <div className="ios-overlay">
                    <div className="ios-sheet" style={{ width: 300, overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
                        <div style={{ padding: '24px 20px 8px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>Excluir Veículo</div>
                            <div style={{ fontSize: 14, color: 'var(--ios-gray)', marginBottom: 20 }}>
                                Deseja excluir <strong>{confirmDelete.nome}</strong>? Esta ação não pode ser desfeita.
                            </div>
                        </div>
                        <div style={{ borderTop: '1px solid var(--ios-separator)', display: 'flex' }}>
                            <button onClick={() => setConfirmDelete(null)} style={{ flex: 1, padding: 14, border: 'none', borderRight: '1px solid var(--ios-separator)', background: 'white', fontSize: 16, color: '#007aff', cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                            <button onClick={() => excluir(confirmDelete.id)} style={{ flex: 1, padding: 14, border: 'none', background: 'white', fontSize: 16, color: '#ff3b30', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Excluir</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
